import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { useCallback } from "react";
import { ListStreams } from "../queries/useListStreams";
import { CreateWebAlertsStreamParams } from "gql/apollo/graphql";

export const CreateWebAlertsStream = graphql(/* GraphQL */ `
	mutation CreateWebAlertsStream($params: CreateWebAlertsStreamParams!) {
		createWebAlertsStream(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

export function useCreateWebAlertsStream() {
	const [createWebAlertsStream] = useMutation(CreateWebAlertsStream, {
		refetchQueries: [ListStreams, "ListStreams"],
	});

	const handleCreateWebAlertsStream = useCallback(
		async (params: CreateWebAlertsStreamParams) => {
			const result = await createWebAlertsStream({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.createWebAlertsStream.success,
				error: result.data?.createWebAlertsStream.error,
			};
		},
		[createWebAlertsStream]
	);

	return { handleCreateWebAlertsStream };
}
